import React from 'react';
import PropTypes from 'prop-types';
import { Button as UDSButton } from '@telus-uds/components-web';

import { ButtonsWrapper, Button, Flex } from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const QuoteSOVButton = ({
  isFormValidated,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  isSubmitting
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: { DOWNLOAD_THE_QUOTE, PROCEED_WITH_THE_ORDER, continueButton }
  } = localizedStringsContext;

  return (
    <ButtonsWrapper>
      <Flex style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        {isFormValidated && (
          <>
            <UDSButton
              type="button"
              onClick={e => onDownloadClick(e)}
              variant={{ priority: 'low' }}
            >
              {DOWNLOAD_THE_QUOTE}
            </UDSButton>
            <UDSButton
              type="button"
              onClick={e => onProceedClick(e)}
              variant={{ priority: 'high' }}
              disabled={isSubmitting}
            >
              {PROCEED_WITH_THE_ORDER}
            </UDSButton>
          </>
        )}

        {!isFormValidated && (
          <UDSButton
            type="button"
            onClick={e => onValidateForm(e)}
            variant={{ priority: 'high' }}
            disabled={isSubmitting}
          >
            {continueButton}
          </UDSButton>
        )}
      </Flex>
    </ButtonsWrapper>
  );
};

QuoteSOVButton.propTypes = {
  isFormValidated: PropTypes.bool.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
};

export default QuoteSOVButton;
